module.exports = __webpack_public_path__ + "img/infaction.f3473f04.svg";